export const ADOVGADO_TITLE = 'Advogado';
export const NACIONALIDADE_TITLE = 'Nacionalidade';
export const OAB_TITLE = 'OAB';
export const SECCIONAL_TITLE = 'Seccional';
